/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Landing_Library_Analyst_ModelsInputs */

const en_landing_library_analyst_models = /** @type {(inputs: Landing_Library_Analyst_ModelsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Analyst models`)
};

/**
* | output |
* | --- |
* | "Analyst models" |
*
* @param {Landing_Library_Analyst_ModelsInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const landing_library_analyst_models = /** @type {((inputs?: Landing_Library_Analyst_ModelsInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Landing_Library_Analyst_ModelsInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_landing_library_analyst_models(inputs)
});